var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 8,
    fill: "#E8B931"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12V15.8206H25.5V12H23.5ZM11.5 24V26H15.3207V24H11.5ZM33.6793 24V26H37.5V24H33.6793ZM32.5257 14.9026L29.854 17.5743L31.259 18.9793L33.9307 16.3076L32.5257 14.9026ZM16.4743 14.9026L15.0693 16.3076L17.741 18.9793L19.146 17.5743L16.4743 14.9026ZM24.5 19C22.8351 19 21.4189 19.5838 20.2513 20.7513C19.0838 21.9189 18.5 23.3351 18.5 25C18.5 26.0153 18.7389 26.9563 19.2167 27.823C19.6944 28.6896 20.3444 29.4068 21.1667 29.9743V35.8716H27.8333V29.9743C28.6556 29.4068 29.3056 28.6896 29.7833 27.823C30.2611 26.9563 30.5 26.0153 30.5 25C30.5 23.3351 29.9162 21.9189 28.7487 20.7513C27.5811 19.5838 26.1649 19 24.5 19ZM23.1667 30.841C23.3889 30.8939 23.609 30.9336 23.827 30.9603C24.045 30.9868 24.2693 31 24.5 31C24.7307 31 24.955 30.9868 25.173 30.9603C25.391 30.9336 25.6111 30.8939 25.8333 30.841V33.8716H23.1667V30.841ZM24.5 21C25.6111 21 26.5556 21.3889 27.3333 22.1666C28.1111 22.9444 28.5 23.8889 28.5 25C28.5 26.1111 28.1111 27.0555 27.3333 27.8333C26.5556 28.6111 25.6111 29 24.5 29C23.3889 29 22.4444 28.6111 21.6667 27.8333C20.8889 27.0555 20.5 26.1111 20.5 25C20.5 23.8889 20.8889 22.9444 21.6667 22.1666C22.4444 21.3889 23.3889 21 24.5 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbIcon);
export default __webpack_public_path__ + "static/media/bulb_icon.af84833ba7db528d40249699b161679f.svg";
export { ForwardRef as ReactComponent };